import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";
import { IUser, SHARE_FEATURE } from "../models/model";
import { FingerprintService } from "../../contract-management/services/fingerprintJs.service";

/**
 * Guards the public "shared-thread" route (a Bob thread's "Anyone with the
 * link" share URL). Sits outside the app's AuthGuard-protected layout so an
 * anonymous visitor isn't redirected to /login — modeled on DocGuard, which
 * does the same for shared documents.
 */
@Injectable({ providedIn: 'root' })
export class ThreadShareGuard implements CanActivate {
    currentUser: IUser | null | undefined = null;

    constructor(
        private authService: AuthenticationService,
        private fingerprintService: FingerprintService,
        private router: Router,
    ) {
        this.authService.currentUser.subscribe(res => {
            this.currentUser = res
        })
    }

    async canActivate(next: ActivatedRouteSnapshot) {
        const threadId = next.queryParams['threadId'];
        const threadMetadataId = next.queryParams['threadMetadataId'];

        if (this.currentUser?._id && !this.currentUser.anonymous) {
            // Already a real logged-in session — send them to the full authenticated
            // thread view; server-side permission checks decide whether they can view it.
            return this.router.createUrlTree(['/bob/thread'], { queryParams: { threadId, threadMetadataId } });
        }

        if (!this.currentUser) {
            await this.fingerprintService.loadFingerprint(null, threadId, SHARE_FEATURE.GENERAL_AGENT);
        }

        return true;
    }
}
